import { BuildingInfo, LoginUser, Pico3, Sensor } from "01Data/DataTypes";
import { Model } from "99Tools/useModel";
import { Chip } from "@mui/material";
import { Auth } from "aws-amplify";
import API from "./API";

export class AccountInfo {
  public user: LoginUser;
  public buildings: BuildingInfo[] = [];
  public sensors: Sensor[] = [];
  public pico3: Pico3[] = [];
  constructor(data: any) {
    this.user = new LoginUser(data);
  }
  public SetData(buildings: BuildingInfo[], sensors: Sensor[], pico3: Pico3[]) {
    this.buildings = buildings.filter(
      (item: BuildingInfo) => item.UserId === this.user.UserId
    );
    this.sensors = sensors.filter((item: Sensor) => {
      const b = this.buildings.filter(
        (b: BuildingInfo) => b.BuildingId === item.BuildingId
      );
      return 0 < b.length;
    });
    this.pico3 = pico3.filter((item: Pico3) => {
      const b = this.buildings.filter(
        (b: BuildingInfo) => b.BuildingId === item.BuildingId
      );
      return 0 < b.length;
    });
  }
  public GetPico3() {
    const list = Array.from(
      new Set(this.pico3.map((item: Pico3) => item.PicoName))
    ).filter((item: string) => item !== "");
    return list
      .sort((a, b) => a.localeCompare(b))
      .map((name) => (
        <Chip
          sx={{ margin: "2px" }}
          size="small"
          key={name}
          label={name}
          variant="outlined"
        />
      ));
  }
  public GetSensors() {
    const list = Array.from(
      new Set(this.sensors.map((item: Sensor) => item.SensorName))
    ).filter((item: string) => item !== "");
    return list
      .sort((a, b) => a.localeCompare(b))
      .map((name) => (
        <Chip
          sx={{ margin: "2px" }}
          size="small"
          key={name}
          label={name}
          variant="outlined"
        />
      ));
  }
}

export class AccountControl extends Model {
  public users: AccountInfo[] = [];
  public errorMessage = "";
  public page = 0;
  public rowsPerPage = 10;
  // アカウント削除用
  public bShowDeleteConfirmDlg = false;
  public deleteAccount = "";
  public deleteAccountName = "";
  // アンドン表示用
  public andonAdminName: string = "";
  public andonAccount: string | null = null;
  public andonID: string | null = null;

  public SetError(err: any, msg: string) {
    this.errorMessage = msg;
    console.log(this.errorMessage);
    console.error(err);
  }

  /**
   * ユーザに関するデータを取得
   */
  public async GetUsers() {
    const data = await API.GetUserData();
    this.users = data.users.map((item: any) => new AccountInfo(item));
    const buildings = data.buildings.map((item: any) => new BuildingInfo(item));
    const sensors = data.sensors.map((item: any) => new Sensor(item));
    const pico3 = data.pico3.map((item: any) => new Pico3(item));
    this.users.forEach((item: AccountInfo) => {
      item.SetData(buildings, sensors, pico3);
    });
    const user = await Auth.currentUserInfo();
    this.andonAdminName = this.users.filter(
      (u: AccountInfo) => u.user.Email === user.attributes.email
    )[0].user.UserName;
  }

  public async DeleteUser(userId: string) {
    await API.DeleteUser(userId);
  }
}
